// extracted by mini-css-extract-plugin
export default {"ExtensionConfigurationHeader":"_ExtensionConfigurationHeader--WlnZ1","ExtensionConfigurationBody":"_ExtensionConfigurationBody--lZNqW"};